<div
  class="p-2 border-2 border-gray-100 hover:border-blue-100 flex justify-content-between cursor-pointer"
  [class.bg-blue-50]="isSelected"
  (click)="selectedBookingChange.emit(booking.orderId)"
>
  <div class="flex-1">
    <div class="flex justify-content-between align-items-center gap-2">
      <!-- The issue count is why the booking is in the queue, so it sits with the order number
           rather than below the detail. -->
      <div class="flex align-items-center gap-2 flex-wrap">
        <h3 class="m-0">{{ booking.orderNumber }}</h3>

        <pill *ngIf="booking.openIssueCount" backgroundColour="bg-red-50" textColour="text-red-600">
          <i class="fa fa-exclamation-circle text-red-500 mr-1"></i>{{ issueCountLabel }}
        </pill>
      </div>

      <div class="flex align-items-center gap-2">
        <!-- Once the job is out with a supplier the fix is a phone call, not an amendment. -->
        <pill
          *ngIf="booking.supplierId"
          backgroundColour="bg-orange-50"
          textColour="text-orange-700"
        >
          <i class="fa fa-truck mr-1"></i>Supplier Allocated
        </pill>

        <pill>
          <span *ngIf="booking.assigneeName"
            >Assigned to <span class="bold-text">{{ booking.assigneeName }}</span></span
          >
          <span *ngIf="!booking.assigneeName">Unassigned</span>
        </pill>
      </div>
    </div>

    <div class="mt-2" *ngIf="firstTask">
      <span class="bold-text">{{ firstTask.pickupLocation }}</span
      >, {{ firstTask.pickupEarliestDateTime | datex : 'ddd, DD MMM' }} &rarr;
      <span class="bold-text">{{ lastTask.dropoffLocation }}</span
      >, {{ lastTask.dropoffLatestDateTime | datex : 'ddd, DD MMM' }}
    </div>

    <div class="text-gray-600 mt-1">
      {{ booking.customerName }}
      <span *ngIf="booking.customerPriority">
        ({{ AMPriorityEnum[booking.customerPriority] }})
      </span>
      &middot; {{ booking.bookingStatus }}
    </div>
  </div>

  <div class="flex align-items-center p-2">
    <i class="fa fa-chevron-right"></i>
  </div>
</div>
